module.exports = __webpack_public_path__ + "img/lyzt_l.7a5d343b.png";